import { InjectionToken } from '@angular/core';
import { BasketService } from '../services/basket.service';

export const BK_SERVICE = new InjectionToken(typeof BasketService);

export const basketProviders = [
  {
    provide: BK_SERVICE,
    useExisting: BasketService,
  },
];
